export const PERSONVAERN_PATH = '/personvaern'
export const LOGIN_PATH = '/login'
export const LOGIN_VERIFY_PATH = '/login/verify/:token/'
export const REGISTER_PATH = '/register/:token/'
export const FORGOT_PATH = '/forgot'
export const LOGIN_REDIRECT_PATH = '/login-redirect'
export const FORGOT_TOKEN_PATH = '/forgot/:token/'
export const PUBLIC_PATH = '/public/*'
